import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            精选八大漫画类型，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 text-center transition-all duration-300 hover:bg-primary-50/50 cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 group-hover:bg-primary-100 group-hover:text-primary-500 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CategorySection;